import { RouteConfig } from "vue-router";
import Activities from "@/modules/security/views/activities/Activities";

export default [
  {
    path: "/dashboard/activities",
    component: Activities,
    meta: { title: "Activities" },
  },
] as RouteConfig[];
